/**
 * The aiming reticle at the centre of the screen.
 *
 * Hidden from assistive technology: it conveys nothing a screen reader can act on, and
 * announcing it would be noise.
 */

export function Crosshair() {
  return <div className="crosshair" aria-hidden="true" />;
}
